export type PostInteractionAction =
  | "like"
  | "heart"
  | "laugh"
  | "sad"
  | "mad"
  | "surprise"
  | "comment"
  | "share";

export const LEADERBOARD_POINTS_CONFIG: Record<PostInteractionAction, number> =
  {
    // Reaction points (per reaction type)
    like: 1,
    heart: 2,
    laugh: 1,
    sad: 1,
    mad: 1,
    surprise: 1,

    // Engagement points
    comment: 3,
    share: 4,
  };
